
import React from 'react';
import BorrowingsLedger from '@/components/accounting/BorrowingsLedger';

export const BorrowingsTab = () => {
  return <BorrowingsLedger />;
};
